import { render, staticRenderFns } from "./PertenenciaSeriesDocumentales.vue?vue&type=template&id=e6cb9d14"
import script from "./PertenenciaSeriesDocumentales.vue?vue&type=script&lang=js"
export * from "./PertenenciaSeriesDocumentales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6cb9d14')) {
      api.createRecord('e6cb9d14', component.options)
    } else {
      api.reload('e6cb9d14', component.options)
    }
    module.hot.accept("./PertenenciaSeriesDocumentales.vue?vue&type=template&id=e6cb9d14", function () {
      api.rerender('e6cb9d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/filtros/PertenenciaSeriesDocumentales.vue"
export default component.exports